import React from 'react';

export const PauseSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4 7.5a3.5 3.5 0 1 1 7 0v9a3.5 3.5 0 1 1-7 0zM7.5 6A1.5 1.5 0 0 0 6 7.5v9a1.5 1.5 0 0 0 3 0v-9A1.5 1.5 0 0 0 7.5 6M13 7.5a3.5 3.5 0 1 1 7 0v9a3.5 3.5 0 1 1-7 0zM16.5 6A1.5 1.5 0 0 0 15 7.5v9a1.5 1.5 0 0 0 3 0v-9A1.5 1.5 0 0 0 16.5 6"
            clipRule="evenodd"
        />
    </svg>
);
